import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import ChatbotContext from '../context/ChatbotContext/ChatbotContext';
import BotBuilderService from '../services/BotBuilderService/BotBuilderService';

const SETTINGS_ROUTE = '/settings';

interface ChatbotCreation {
  createChatbot: (name: string) => Promise<void>;
}

function useChatbotCreation(): ChatbotCreation {
  const { selectedOrganisation, setCurrentChatbot } =
    useContext(ChatbotContext);
  const navigate = useNavigate();

  const createChatbot = async (name: string): Promise<void> => {
    if (!selectedOrganisation) return;

    const created = await BotBuilderService.createChatbot(
      selectedOrganisation.id,
      name
    );
    await setCurrentChatbot(created.id);
    navigate(SETTINGS_ROUTE);
  };

  return { createChatbot };
}

export default useChatbotCreation;
